import { Component, OnInit, Input, Inject, LOCALE_ID } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-action-modal',
  templateUrl: './confirm-action-modal.component.html',
  styleUrls: ['./confirm-action-modal.component.scss']
})
export class ConfirmActionModalComponent implements OnInit {

  @Input() content: string | {
    "en-us": string,
    "pt-br": string
  };

  @Input() title: string | {
    "en-us": string,
    "pt-br": string
  };

  @Input() canCancel = true;

  constructor(
    public activeModal: NgbActiveModal,
    @Inject(LOCALE_ID) private locale: string,
  ) { }

  ngOnInit() {
  }

  isEnglishLocale() {
    return !(typeof this.locale === "string" && this.locale.toLowerCase().substring(0, 2) === "pt");
  }

  get headerText() {
    if (typeof this.title === "string") {
      return this.title;
    }

    if (this.isEnglishLocale()) {
      if (!this.title || !this.title["en-us"]) {
        return "Confirm";
      }
      return this.title["en-us"];
    }

    if (!this.title || !this.title["pt-br"]) {
      return "Confirmar";
    }
    return this.title["pt-br"];
  }

  get text() {
    if (!this.content) {
      return "";
    }

    if (typeof this.content === "string") {
      return this.content;
    }

    if (this.isEnglishLocale()) {
      if (!this.content || !this.content["en-us"]) {
        return "";
      }
      return this.content["en-us"];
    }

    if (!this.content || !this.content["pt-br"]) {
      return "";
    }
    return this.content["pt-br"];
  }

}
